import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/** Plain text for tooltip labels (strip lightweight markdown). */
export const plainMarkdownTableCellText = (raw) => {
  let text = String(raw || '').trim();
  if (!text) return '';
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1');
  text = text.replace(/\*([^*]+)\*/g, '$1');
  text = text.replace(/__([^_]+)__/g, '$1');
  text = text.replace(/`([^`]+)`/g, '$1');
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  return text.replace(/\s+/g, ' ').trim();
};

const isTruncated = (el) => {
  if (!el) return false;
  return el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
};

/**
 * Table cell with ellipsis + map-hover-tooltip when content is clipped.
 */
export function MarkdownTableCell({ cellText, children, as: Tag = 'td', className = '' }) {
  const innerRef = useRef(null);
  const [tip, setTip] = useState(null);
  const label = plainMarkdownTableCellText(cellText);

  const showTip = (event) => {
    if (!label || !isTruncated(innerRef.current)) {
      setTip(null);
      return;
    }
    setTip({ x: event.clientX, y: event.clientY, text: label });
  };

  const moveTip = (event) => {
    setTip((prev) => (prev ? { ...prev, x: event.clientX, y: event.clientY } : null));
  };

  const hideTip = () => setTip(null);

  return (
    <>
      <Tag className={className}>
        <span
          ref={innerRef}
          className="md-table-cell-inner"
          onMouseEnter={showTip}
          onMouseMove={moveTip}
          onMouseLeave={hideTip}
        >
          {children}
        </span>
      </Tag>
      {tip && typeof document !== 'undefined' && createPortal(
        <div
          className="map-hover-tooltip"
          style={{ top: tip.y + 15, left: tip.x + 15 }}
          role="tooltip"
        >
          {tip.text}
        </div>,
        document.body,
      )}
    </>
  );
}
